/**
 * Class accordion
 */
class Accordion {
	transition: number;
	triggers: JQuery;
	accordion: JQuery;

	constructor(element: JQuery) {
		this.accordion = element;
		this.triggers = this.accordion.find('.block-bellow__top');
		this.transition = 300;

		this.triggers.on('click', this.handleBellowClick.bind(this));

		this.checkHashAndExpand();
	}

	/**
	 * Handle bellow click
	 *
	 * @param {Event} event
	 */
	handleBellowClick(event: Event) {
		const target = event.currentTarget as Element;

		const isExpanded = target
			?.closest('.block-bellow')
			?.classList.contains('block-bellow--expanded');

		if (isExpanded) {
			this.collapseBellow(target);
		} else {
			this.expandBellow(target);
		}
	}

	/**
	 * Collapse Bellow
	 *
	 * @param {HTMLElement} element Event target
	 */
	collapseBellow(element: Element) {
		const bellowTrigger = $(element);

		bellowTrigger
			.attr('aria-expanded', 'false')
			.parents('.block-bellow')
			.removeClass('block-bellow--expanded')
			.find('.block-bellow__collapsable')
			.slideUp(this.transition);
	}

	/**
	 * Expand Bellow
	 *
	 * @param {HTMLElement} element Event target
	 */
	expandBellow(element: Element) {
		const bellow = $(element);

		// Collapse other bellow if exists and not multiple open by default.
		const expandedBellow = document.querySelector('.block-bellow--expanded .block-bellow__top');
		if (null !== expandedBellow && $('.block-bellow--open-default').length < 2) {
			this.collapseBellow(expandedBellow);
		}

		// Expand bellow.
		bellow
			.attr('aria-expanded', 'true')
			.parents('.block-bellow')
			.addClass('block-bellow--expanded')
			.find('.block-bellow__collapsable')
			.slideDown(this.transition);
	}

	/**
	 * Check URL hash and expand the corresponding bellow
	 */
	checkHashAndExpand() {
		const hash = window.location.hash;
		if (hash) {
			const target = this.accordion.find(hash);
			if (target.length) {
				this.expandBellow(target[0]);
				this.scrollToElement(target[0]);
			}
		}
	}

	/**
	 * Scroll to element
	 *
	 * @param {HTMLElement} element Element to scroll to
	 */
	scrollToElement(element: Element) {
		element.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}
}

$('.block-accordion').each(function () {
	new Accordion($(this));
});
